import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Teams from './components/Page1';
import Players from './components/Page2';
import Batsmans from './components/Page3';
import Page4 from './components/page4';
import NewBatsman from './components/Page5';
import OversSummary from './components/oversummary';
import Scoreboardbatting from './components/batscorecard';
import ScoreboardBowling from './components/bowscorecard';
import SummaryPage from './components/summary';
import OversChart from './components/overchart';
import Fullscorecard from './components/fullscorecard';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Teams />} />
        <Route path="/players" element={<Players />} />
        <Route path="/live" element={<Batsmans />} />
          <Route path="/newbowler" element={ <Page4/>  } />
           <Route path="/newbatsman" element={ <NewBatsman/>  } />
           <Route path="/overs" element={ <OversSummary/>  } />
                 <Route path="/batstats" element={ <Scoreboardbatting/>  } />
                 <Route path="/bowlstats" element={ <ScoreboardBowling/>  } />
                     <Route path="/summary" element={ <SummaryPage/> } />
                      <Route path="/chart" element={ <OversChart/> } />
                      <Route path="/full" element={ <Fullscorecard/> } />
      </Routes>
    </Router>
  );
}

export default App;
